module.exports = __webpack_public_path__ + "img/video-player/outage-feee779f027d5592dca17f6d27eb9fbb.png";